// libs
import React from 'react';
import PropTypes from 'prop-types';

// Component
import Image from '../../../tools/image/Image';

// Styles
import './styles.scss';

function TwoColumns(props) {
  const {
    image,
    text,
  } = props;
  return (
    <div className="flexible-content__item flexible-content__two-columns">
      <Image
        alt={image.alt}
        className="flexible-content__two-columns__image"
        mediaUrl={image.sizes.large}
      />
      <div
        dangerouslySetInnerHTML={{ __html: text }}
        className="flexible-content__two-columns__text wysiwyg"
      />
    </div>
  );
}

TwoColumns.propTypes = {
  image: PropTypes.object.isRequired,
  text: PropTypes.string.isRequired,
};


export default TwoColumns;



// WEBPACK FOOTER //
// ./src/app/components/pages/default/flexibleContents/TwoColumns.js